import {Directive, ElementRef, HostListener, Input, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {TooltipService} from 'app/core/services/tooltip.service';

export const TOOLTIP_DELAY = 500;

@Directive({
    selector: '[tooltip]',
})
export class TooltipDirective implements OnInit, OnDestroy {
    @Input() tooltip: string;
    @Input() tooltipTemplate: TemplateRef<any>;
    @Input() delay = 500;
    @Input() context: any;
    private visible = false;
    private showTimerId;

    constructor(
        private tooltipService: TooltipService,
        private $el: ElementRef
    ) {}

    ngOnInit() {
        this.delay = this.delay === undefined ? TOOLTIP_DELAY : this.delay;
    }

    ngOnDestroy() {
        this.hideTooltip();
    }

    private getTooltipContent() {
        return this.tooltipTemplate ? this.tooltipTemplate : this.tooltip;
    }

    private hideTooltip() {
        clearTimeout(this.showTimerId);
        if (this.visible) {
            this.tooltipService.hideTooltip();
        }
    }

    @HostListener('mouseenter')
    onMouseEnter() {
        let content = this.getTooltipContent();
        let rect = this.$el.nativeElement.getBoundingClientRect();
        if (content) {
            this.showTimerId = setTimeout(() => {
                this.visible = true;
                this.tooltipService.showTooltip(content, rect, this.context);
            }, this.delay);
        }
    }

    @HostListener('mousedown')
    onMouseDown() {
        this.hideTooltip();
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.hideTooltip();
    }
}
